import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "@radix-ui/react-icons";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "testify-peer testify-h-4 testify-w-4 testify-shrink-0 testify-rounded-sm testify-border testify-border-primary testify-shadow testify-focus-visible:outline-none testify-focus-visible:ring-1 testify-focus-visible:ring-ring testify-disabled:cursor-not-allowed testify-disabled:opacity-50 testify-data-[state=checked]:bg-primary testify-data-[state=checked]:text-primary-foreground",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        "testify-flex testify-items-center testify-justify-center testify-text-current",
      )}
    >
      <CheckIcon className="testify-h-4 testify-w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
